import {
  BatchInfo as BatchInfoType,
  RunType,
  ShopperSessionStatus,
  WPosition,
} from '../../../AboutShift/types/';
import {Box, HBox} from '../../../components/core/view';
import {
  CameraComponentState,
  getClientType,
  getStoreName,
} from '@buncha/common/types/common';
import {
  DeliveryLocationStatus,
  OrderItemStatus,
} from '../../../batchDetails/types';
import {
  HomeScreens,
  ShopperScreens,
} from '../../../../src/home/navigation/types';
import {Linking, Platform} from 'react-native';
import {
  PERMISSIONS,
  check,
  checkLocationAccuracy,
} from 'react-native-permissions';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {
  convertBase64,
  getOS,
  isWeb,
  requestPermissions,
  useCheckIfB2BStore,
} from '@buncha/utils/common';
import {
  useAboutShiftContext,
  useGetBatches,
  useUpdateShopperSessionStatus,
} from '../../../AboutShift/hooks/AboutShift';
import {useAppDispatch, useAppSelector} from '../../../config/redux/hooks';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';
import {
  useGetItemStatusCount,
  useGetMinimumDeliveryStatus,
  useVanDeliveryImages,
} from '../../../batchDetails/hooks/OrderOperation';
import {useIsFocused, useRoute} from '@react-navigation/native';

import {Analytics} from '../../../config/analytics/analytics';
import BagTrackingModal from '../BagTrackingModal';
import BatchInfo from '../BatchInfo';
import BatchListHeader from '../BatchListHeader';
import CameraModal from '@buncha/common/components/CameraModal/CameraModal';
import {CustomText} from '@buncha/components/core/text';
import DeliveryVanIcon from '@buncha/components/core/icon/DeliveryVanIcon';
import {Divider} from 'native-base';
import DriverBarCodeEducationBottomsheet from '../DriverBarCodeEducationBottomsheet';
import DriverLoginModal from '../driverLoginModal';
import {DriverScreens} from '../../../../src/driver/navigation/type';
import {EventType} from '../../../config/analytics/type';
import If from '@buncha/components/conditional/If';
import ImageBottomSheet from '@buncha/common/components/BottomSheet/ImageBottomSheet';
import LocationPermissionModal from '../LocationPermissionModal';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {OnfleetConfig} from '@buncha/config/onfleet/types';
import {PButton} from '../../../components/core/Button';
import {PrinterMange} from '@buncha/components/type';
import {UserTypes} from '@buncha/onBoarding/types';
import VanLocation from '../VanLocation';
import {b2bNav} from '@buncha/B2B/navigation';
import {batchDetailsActions} from '@buncha/batchDetails/reducer';
import {gqlService} from '@buncha/config/graphQL';
import listener from '../../../config/listener';
import {navigation} from '../../../config/navigation';
import onfleetService from '@buncha/config/onfleet';
import {shouldAnalyticsLoad} from '@buncha/config/analytics/utils';
import {smartLook} from '@buncha/config/analytics';
import {styles} from './style';
import {useCheckSubmittedBagCount} from '@buncha/AboutShift/hooks/BagTracking';
import {useGetLocale} from '@buncha/localization/hooks';
import {useIsMeijerStore} from '@buncha/home/hooks/home';

interface BatchListItemProps {
  index: number;
  item: BatchInfoType;
  coordinates?: {lat: number; long: number};
  activeShift: boolean;
  online: boolean;
  batchNo?: number;
  onValueChange: () => void;
  inspectVan: boolean;
}

function BatchListItem(props: Readonly<BatchListItemProps>) {
  const {item, coordinates, activeShift, inspectVan} = props;
  const muliFont = useFontTheme('muli');
  const route = useRoute();
  const params: {shiftId?: string; shiftKey?: string} | undefined =
    route?.params;
  const appDispatch = useAppDispatch();
  const {dispatch} = useAboutShiftContext();

  const {checkIfB2BStore} = useCheckIfB2BStore();
  const [updateShopperSessionStatus] =
    useUpdateShopperSessionStatus(appDispatch);
  const globalDriver = useAppSelector(gState => gState.home.driver);
  const theme = useColorThemeType();
  const [getItemStatusCount, countState] = useGetItemStatusCount(null);
  const isFocused = useIsFocused();

  const [checkSubmittedBagCount, submitBagState] = useCheckSubmittedBagCount();
  const [bagCountModal, setBagCountModal] = useState(false);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [getBatches] = useGetBatches(dispatch);
  const [educationSheetOpen, setEducationSheetOpen] = useState(false);
  const toggleEducationSheet = useCallback(() => {
    setEducationSheetOpen(!educationSheetOpen);
  }, [educationSheetOpen]);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const [driverLoginModal, setDriverLoginModal] = useState(false);
  const [locationPermissionModal, setLocationPermissionModal] = useState(false);
  const {title, body} =
    useGetLocale(Modules.aboutShift, HomeScreens.AboutShift) ?? {};

  const isDriverLoggedIn = Boolean(
    useAppSelector(gState => gState.home.driver?.id),
  );

  const gbDriverState = useAppSelector(gbState => gbState.driver);
  const disablePrinterFlow = gbDriverState.disablePrinterFlow;

  const constatns = useAppSelector(gbState => gbState.onboarding.constants);
  const currentUserId = useAppSelector(
    gState => gState.onboarding.currentUser?.id,
  );

  const hasPrinterEnabled = useMemo(() => {
    let printerMange: PrinterMange | undefined;
    try {
      printerMange =
        constatns?.PRINTER_MANAGE && JSON.parse(constatns?.PRINTER_MANAGE);
    } catch (err: any) {
      printerMange = undefined;
    }
    if (!printerMange || !currentUserId) return false;
    if (printerMange.allUsers) return true;
    return printerMange.users?.includes(currentUserId);
  }, [constatns?.PRINTER_MANAGE, currentUserId]);

  const toggleCameraModal = useCallback(() => {
    setOpenCameraModal(!openCameraModal);
  }, [openCameraModal]);

  const toggleDriverModal = useCallback(() => {
    setDriverLoginModal(s => !s);
  }, []);

  const toggleLocationPermissionModal = useCallback(() => {
    setLocationPermissionModal(s => !s);
  }, []);

  const {
    confirmVanImages,
    vanImages,
    vanDeliveryImageLoading,
    deleteVanImage,
    uploadVanImage,
  } = useVanDeliveryImages();
  const [getMinimumDeliveryStatus, minStatusState] =
    useGetMinimumDeliveryStatus(dispatch);

  const currentActiveBatch = Boolean(activeShift);
  const shopperSession = item.shopperSession;
  const taskFinished = Boolean(item.state === WPosition.none);
  const shopperTask = Boolean(item.state === WPosition.Shopper);
  const loading =
    !currentActiveBatch ||
    countState.loading ||
    taskFinished ||
    submitBagState.loading ||
    minStatusState.loading ||
    minStatusState.loading;

  const store = item.shift[item.activeShiftIndex].store;
  const masterRun = item?.run?.masterRun;
  const runType = item?.run.runType;
  const runId = item?.run?.id;
  const storeId = item?.run?.store?.id;

  const isMeijer = useIsMeijerStore(storeId);

  const taskCount = shopperTask
    ? item?.task.shopperTask
    : item?.task.driverTask;

  const minimumOrderStatusForDriver = useMemo(() => {
    return [
      DeliveryLocationStatus.driverAssigned,
      DeliveryLocationStatus.onTheWay,
      DeliveryLocationStatus.delivered,
    ];
  }, []);

  const getButtonText = useMemo(() => {
    const ctaName = item?.ctaName ?? '';
    if (ctaName) return ctaName;
    switch (item?.state) {
      case WPosition.none:
        return body?.buttonStatus?.shiftFinished;
      case WPosition.Driver:
        return body?.buttonStatus?.arrivedAtStore;
      default:
        return body?.buttonStatus?.startShopping;
    }
  }, [
    body?.buttonStatus?.arrivedAtStore,
    body?.buttonStatus?.shiftFinished,
    body?.buttonStatus?.startShopping,
    item?.ctaName,
    item?.state,
  ]);

  const hasDriverShift = useMemo(() => {
    return item.state === WPosition.Driver;
  }, [item.state]);

  const hasNormalRun = useMemo(() => {
    return runType === RunType.normal;
  }, [runType]);

  const navigateToVanLoad = useCallback(() => {
    toggleEducationSheet();
    return navigation.navigate(MainScreens.Driver, {
      screen: DriverScreens.LoadVanAt,
      params: {runId: item?.run?.id},
    });
  }, [item?.run?.id, toggleEducationSheet]);

  const navigateToBatchDetail = useCallback(() => {
    const eventParams = {
      type: EventType.cta,
      storeName: store?.name,
      runId: runId,
      orderCount: taskCount?.orderCount,
      itemCount: taskCount?.itemCount,
      client: getClientType(isMeijer),
      storeType: getStoreName(String(storeId)),
    };
    Analytics.eventWithProps(`${getButtonText}`, eventParams);
    smartLook.trackCustomEvent(`${getButtonText}`, eventParams);
    navigation.navigate(HomeScreens.Shopper, {
      screen: ShopperScreens.BatchDetailsPage,
      params: {runId: item.run.id},
    });
  }, [
    getButtonText,
    isMeijer,
    item.run.id,
    runId,
    store?.name,
    storeId,
    taskCount?.itemCount,
    taskCount?.orderCount,
  ]);

  const onPressGoPicked = useCallback(() => {
    if (shopperSession?.sessionStatus === ShopperSessionStatus.notStarted)
      updateShopperSessionStatus(
        shopperSession?.id,
        ShopperSessionStatus.started,
        shopperSession?.shiftId,
        coordinates?.lat ?? 0,
        coordinates?.long ?? 0,
      );
    navigateToBatchDetail();
  }, [
    coordinates?.lat,
    coordinates?.long,
    navigateToBatchDetail,
    shopperSession?.id,
    shopperSession?.sessionStatus,
    shopperSession?.shiftId,
    updateShopperSessionStatus,
  ]);

  const navigateToOrderPack = useCallback(
    (minStatus?: DeliveryLocationStatus) => {
      Analytics.eventWithProps(`${getButtonText}`, {
        type: EventType.cta,
        storeName: store?.name,
        runId: runId,
        orderCount: taskCount?.orderCount,
        itemCount: taskCount?.itemCount,
        client: getClientType(isMeijer),
        storeType: getStoreName(String(storeId)),
      });

      if (minStatus === DeliveryLocationStatus.toBeAssigned && !hasNormalRun)
        navigation.navigate(HomeScreens.Shopper, {
          screen: ShopperScreens.VanLoadSite,
          params: {runId: item.run.id},
        });
      else
        navigation.navigate(HomeScreens.Shopper, {
          screen: ShopperScreens.OrderPackingPage,
          params: {runId: runId},
        });
    },
    [
      getButtonText,
      hasNormalRun,
      isMeijer,
      item.run.id,
      runId,
      store?.name,
      storeId,
      taskCount?.itemCount,
      taskCount?.orderCount,
    ],
  );

  const navigateToDriverOrders = useCallback(
    (minStatus?: DeliveryLocationStatus) => {
      if (
        (minStatus && minimumOrderStatusForDriver.includes(minStatus)) ||
        hasNormalRun
      )
        return navigation.navigate(MainScreens.Driver, {
          screen: DriverScreens.DriverOrders,
          params: {runId: runId, storeId: storeId},
        });
      else if (!hasPrinterEnabled || isWeb() || disablePrinterFlow)
        navigateToVanLoad();
      else toggleEducationSheet();
    },
    [
      disablePrinterFlow,
      hasNormalRun,
      hasPrinterEnabled,
      minimumOrderStatusForDriver,
      navigateToVanLoad,
      runId,
      storeId,
      toggleEducationSheet,
    ],
  );

  const onPress = useCallback(async () => {
    gqlService?.updateIsMeijer(checkIfB2BStore(store?.id));
    if (hasDriverShift) {
      if (!inspectVan) {
        let userType = UserTypes.driver;
        const minOrderStatusForDriver = await getMinimumDeliveryStatus(
          runId,
          userType,
        );
        Analytics.eventWithProps(`${getButtonText}`, {
          type: EventType.cta,
          storeName: store?.name,
          runId: runId,
          orderCount: taskCount?.orderCount,
          itemCount: taskCount?.itemCount,
          client: getClientType(isMeijer),
          storeType: getStoreName(String(storeId)),
        });
        return navigateToDriverOrders(minOrderStatusForDriver);
      }
      return setImageModalOpen(true);
    }

    const minOrderStatus = await getMinimumDeliveryStatus(runId);

    appDispatch(batchDetailsActions.setBatchTaskInfo(item?.task));

    if (minOrderStatus === DeliveryLocationStatus.notStarted)
      return onPressGoPicked();
    if (minOrderStatus === DeliveryLocationStatus.orderPacked && isMeijer)
      return b2bNav.B2BCheckout({
        runId,
        storeId: store?.id,
        storeIndex: store?.elasticSearchIndex,
      });
    return navigateToOrderPack(minOrderStatus);
  }, [
    checkIfB2BStore,
    store?.id,
    store?.elasticSearchIndex,
    store?.name,
    hasDriverShift,
    getMinimumDeliveryStatus,
    runId,
    appDispatch,
    item?.task,
    onPressGoPicked,
    isMeijer,
    navigateToOrderPack,
    inspectVan,
    getButtonText,
    taskCount?.orderCount,
    taskCount?.itemCount,
    storeId,
    navigateToDriverOrders,
  ]);

  const getOrganization = useCallback(() => {
    const onfleetConfigString = constatns?.ONFLEET_CONFIG_ID;
    const onfleetConfig: OnfleetConfig = JSON.parse(
      onfleetConfigString ?? '{}',
    );
    const organizationToSwitch = isMeijer
      ? onfleetConfig?.b2bOrganization
      : onfleetConfig?.bunchaOrganization;
    const organization = shouldAnalyticsLoad('strict')
      ? organizationToSwitch?.prod
      : organizationToSwitch?.dev;
    return organization;
  }, [constatns?.ONFLEET_CONFIG_ID, isMeijer]);

  const toggleBagCountModal = useCallback(() => {
    setBagCountModal(!bagCountModal);
  }, [bagCountModal]);

  const onShiftSubmit = useCallback(async () => {
    if (item?.state === WPosition.Driver && !isWeb()) {
      const access = Platform.select({
        android: PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION,
        ios: PERMISSIONS.IOS.LOCATION_ALWAYS,
      });
      const isIOS = getOS() === 'ios';
      if (!access) return;
      const status = await check(access);
      const iOSPreciseStatus =
        status === 'granted' && isIOS
          ? await checkLocationAccuracy()
          : 'reduced';
      const preciseStatus = isIOS ? iOSPreciseStatus : 'full';
      if (status !== 'granted' || preciseStatus !== 'full')
        return toggleLocationPermissionModal();
      if (isDriverLoggedIn) {
        const organizationToSwitch = getOrganization();
        if (
          organizationToSwitch &&
          organizationToSwitch !== globalDriver?.organization
        )
          await onfleetService.switchAccount(organizationToSwitch);
      } else {
        return toggleDriverModal();
      }
    }
    const showStartingBagCount =
      constatns?.SHOW_STARTING_BAG_COUNT_MODAL &&
      JSON.parse(constatns?.SHOW_STARTING_BAG_COUNT_MODAL);
    if (
      hasDriverShift ||
      submitBagState.data?.bagsCount ||
      !showStartingBagCount
    )
      onPress();
    else toggleBagCountModal();
  }, [
    item?.state,
    constatns?.SHOW_STARTING_BAG_COUNT_MODAL,
    hasDriverShift,
    submitBagState.data?.bagsCount,
    toggleBagCountModal,
    isDriverLoggedIn,
    onPress,
    globalDriver,
    getOrganization,
    toggleDriverModal,
    toggleLocationPermissionModal,
  ]);

  const bagCountModalSubmit = useCallback(() => {
    toggleBagCountModal();
    onPress();
  }, [onPress, toggleBagCountModal]);

  const onRefreshEvent = useCallback(() => {
    if (runId && currentActiveBatch)
      getItemStatusCount(runId, [
        OrderItemStatus.notPicked,
        OrderItemStatus.picked,
      ]);
  }, [currentActiveBatch, getItemStatusCount, runId]);

  const uploadVanLoadImageWeb = useCallback(
    async (file: any) => {
      let imgArray: any = [];
      let fileArray: any = Object.values(file.target.files);
      for (let i = 0; i < fileArray.length; i++) {
        const base64Data = await convertBase64(fileArray[i]);
        const base64Trimeed = base64Data as string;
        const returnData = {
          uri: fileArray[i].name,
          base64: base64Trimeed.split(',')[1],
        };
        imgArray[i] = returnData;
      }

      uploadVanImage(imgArray[0]?.base64, runId);
    },
    [runId, uploadVanImage],
  );

  const onConfirmhandler = useCallback(async () => {
    if (!params?.shiftId) return;
    await confirmVanImages(params?.shiftId);
    setImageModalOpen(false);
    getBatches(params?.shiftId);
  }, [confirmVanImages, getBatches, params?.shiftId]);

  const captureImageHandler = useCallback(
    async (data?: any) => {
      if (data && isWeb()) return uploadVanLoadImageWeb(data);
      const permissionStatus = await requestPermissions();
      if (permissionStatus)
        try {
          toggleCameraModal();
        } catch (error) {}
      else Linking.openSettings();
    },
    [toggleCameraModal, uploadVanLoadImageWeb],
  );

  useEffect(() => {
    if (runId && currentActiveBatch && isFocused)
      getItemStatusCount(runId, [
        OrderItemStatus.notPicked,
        OrderItemStatus.picked,
      ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runId, currentActiveBatch, isFocused]);

  useEffect(() => {
    if (isFocused && runId) checkSubmittedBagCount(runId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, runId]);

  useEffect(() => {
    const itemStatusCount = listener.addListener(
      'getItemStatusCount',
      onRefreshEvent,
    );
    return itemStatusCount;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getHeaderTitle = useMemo(() => {
    if (!hasDriverShift) return body?.headerTitle?.shoppingLocation;
    return body?.headerTitle?.vanLoadLocation;
  }, [
    body?.headerTitle?.shoppingLocation,
    body?.headerTitle?.vanLoadLocation,
    hasDriverShift,
  ]);

  const imageUploadHandler = useCallback(
    (data: CameraComponentState) => {
      if (data) uploadVanImage(data.base64, runId);
    },
    [runId, uploadVanImage],
  );

  return (
    <Box>
      <BatchListHeader headerTitle={getHeaderTitle} />
      <BatchInfo
        run={item.run}
        taskCount={item.task.shopperTask}
        hideDriverInfo={!hasDriverShift && !hasNormalRun}
        hideStoreInfo={hasDriverShift}
      />
      <PButton
        title={getButtonText}
        style={[styles.actionButton]}
        titleStyle={{
          fontFamily: muliFont[700].normal,
        }}
        isLoading={loading}
        changeStyleOnLoading
        loadingText={getButtonText}
        onPress={onShiftSubmit}
      />
      <If condition={!hasNormalRun && masterRun && !hasDriverShift}>
        <Divider style={styles.loader} />
        <VanLocation batchInfo={item} />
      </If>
      <If condition={bagCountModal}>
        <BagTrackingModal
          isOpen={bagCountModal}
          onClose={toggleBagCountModal}
          onSubmit={bagCountModalSubmit}
          runId={item.run.id}
        />
      </If>
      <If condition={inspectVan && hasDriverShift}>
        <HBox style={styles.deliveryBox}>
          <DeliveryVanIcon viewBox="0 0 35 35" fill={theme?.icon.blue[300]} />
          <CustomText style={styles.text}>
            {body?.completeInspection}
          </CustomText>
        </HBox>
      </If>
      <ImageBottomSheet
        bottomSheetOpen={imageModalOpen}
        title={title?.attachCheckList}
        subtitle={body?.fillVanQuantityForm}
        loading={vanDeliveryImageLoading}
        imageList={vanImages}
        showCaptureModeFunc={captureImageHandler}
        closeBottomSheet={() => setImageModalOpen(false)}
        handleImageDelete={deleteVanImage}
        hasDeleteModal
        uploadButtonHandler={onConfirmhandler}
        hasShowBottomButton
      />
      <If
        condition={
          educationSheetOpen && hasPrinterEnabled && !disablePrinterFlow
        }>
        <DriverBarCodeEducationBottomsheet
          open={educationSheetOpen}
          onClose={toggleEducationSheet}
          onPress={navigateToVanLoad}
        />
      </If>

      <If condition={openCameraModal}>
        <CameraModal
          capturedImage={imageUploadHandler}
          open={openCameraModal}
          closeModal={toggleCameraModal}
        />
      </If>
      <DriverLoginModal
        open={driverLoginModal}
        onClose={toggleDriverModal}
        afterLogin={onPress}
        source={'Van Load'}
      />
      <If condition={locationPermissionModal}>
        <LocationPermissionModal
          open={locationPermissionModal}
          onClose={toggleLocationPermissionModal}
        />
      </If>
    </Box>
  );
}

export default React.memo(BatchListItem);
